export default "__VITE_ASSET__n$0vPb$G__"